var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDoneDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#2D2D2D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#23BE00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 8.40002H12H21H21.6V9.00002V16.0357C21.4033 16.0121 21.2031 16 21 16C20.797 16 20.5967 16.0121 20.4 16.0356V9.60002H12H11.4V8.40002ZM18.6 16.6126V12V11.4H18H9.00002H8.40002V12V21V21.6H9.00002H16.0356C16.0121 21.4033 16 21.2031 16 21C16 20.797 16.0121 20.5967 16.0356 20.4H9.60002V12.6H17.4V17.5301C17.75 17.1671 18.1544 16.8569 18.6 16.6126Z",
    fill: "#23BE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.353 19.8236L20.2139 22.7648L18.6471 21.2942",
    stroke: "#23BE00",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDoneDark);
export default __webpack_public_path__ + "static/media/copy-done-dark.b8dc4720291f575ebdf7fa99b7c05d68.svg";
export { ForwardRef as ReactComponent };